import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Table, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import Inputmask from 'inputmask';
import SvgIcon from 'react-icons-kit';
import {download} from 'react-icons-kit/fa/download';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';

var Config = require('../../../config');
var socket = "";

class ModalSample extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getNextNumber = this.getNextNumber.bind(this);
		this.onSave = this.onSave.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.clear = this.clear.bind(this);
		this.onChecked = this.onChecked.bind(this);

		this.state = {
			show: false,
			samples:[],

			entry_date:"",
			entry_hour:"",
			sample_number:"",
			sample_date:"",
			sample_hour:"",
			origin:"",
			sample_person:"",
			petition_id:"",
			convoke_places:[],
			convoke_places_id:"",
			samples_id:"",

			antibodies_required: null,
			donation_id: "",
			donor_id: "",
			number: "",
			offers_id: "",
			sample_types_id:"",
			storage_ubication_id:"",
			validated:"",
			validation_status:"",

			
			sample:"",
			showForm: false,
			patient_id:"",
			disableSave:false,

			preview_print:{},
			no_apto: false,
			reasons:[],
			reason_id:"",
			reject_id:"",
			observations:"",

		}
	}

	componentDidMount(){
		this.props.onRef(this);

		socket= this.props.socket !== undefined && this.props.socket !== "" ? this.props.socket : new WebSocket("wss://localhost:2018");

		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		this.getServerTime();
		this.getPlaces();

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=rejection_reasons_samples&option=actives&order=true',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				reasons: response
			});
		})
	}

	getServerTime(type){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
            	this.props.waiting.handleClose();
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-');
			var hours = this.getHourFormat(aux[1]);

			if(type === 'entry'){
				this.setState({
					entry_date: date,
					entry_hour:hours,
				});
			}else{
				this.setState({
					entry_date: date,
					entry_hour:hours,
					sample_date:date,
					sample_hour: hours
				});
			}

				

			this.props.waiting.handleClose();
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;
		var value = e.target.value;

		this.setState({
			[e.target.name]: e.target.value
		});

		if(campo === 'sample'){
			setTimeout(()=>{
				this.onUpdate();
			}, 500);
		}else{
			if(value !== ""){
				setTimeout(()=>{
					this.showCtrlError(campo);

				}, 500);
			}
		}
	}

	getPlaces(){
		fetch(Config.default.apiGateway.URL+'convoke_places?option=operatives&health_facilities_id='+
				sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
		      convoke_places: response
		    });
		});
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(petition_id, patient_id, sample_id){
		this.setState({
			show: true,
			petition_id: petition_id,
			patient_id: patient_id,
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'petitions/get_samples?petition_id='+petition_id, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');	
				});
				
			}
		}).then(response => {
			if(response !== undefined){
				if(response.length > 0){
					var last = response.length - 1;
					var index = response.findIndex(obj => 
						obj.sample.id === sample_id
					)
					
					this.setState({
						samples: response,
						sample:response[index].sample.id
					});
					
					this.onUpdate();
				}
				
			}
		});		

		setTimeout(()=>{
			var selector_entry = document.getElementById("entry_hour");
			var selector_sample = document.getElementById("sample_hour");
			var im = new Inputmask("--:--");
		
			if(selector_entry !== null){
				im.mask(selector_entry);
				im.mask(selector_sample);	
			}
		},500)
	}

	handleClose(){
		this.setState({
			show: false,
			entry_date:"",
			entry_hour:"",
			sample_number:"",
			sample_date:"",
			sample_hour:"",
			origin:"",
			sample_person:"",
			petition_id:"",
			convoke_places:[],
			convoke_places_id:"",
			samples_id:"",

			antibodies_required: null,
			donation_id: "",
			donor_id: "",
			number: "",
			offers_id: "",
			sample_types_id:"",
			storage_ubication_id:"",
			validated:"",
			validation_status:"",

			samples:[],
			sample:"",
			showForm:false,
			preview_print:{},
		});

		//this.props.getList();
	}

	getNextNumber(){
		fetch(Config.default.apiGateway.URL+'samples/get_next_number?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
			'&sample_type=PATIENT',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({sample_number:response});
				this.showCtrlError('sample_number');
			}
		})
	}

	onSave(){
		if(this.state.showForm){
			if(this.isValidForm()){
				var obj = {};
				var api = '';
				var method = '';
				var date = moment(this.state.entry_date+' '+this.state.entry_hour, 'YYYY-MM-DD H:mm').format('MM-DD-YYYY H:mm');
				
				if(this.state.samples_id !== ""){
					api = 'samples/update_patient_sample';
					method = 'PUT';

					var index = this.state.samples.findIndex(obj => obj.sample.id === this.state.samples_id
						);
					obj = this.state.samples[index];
					if(obj.petition_has_sample !== null){
						obj.petition_has_sample.petitions_id = this.state.petition_id;
						obj.petition_has_sample.entry_date = date;
					}else{
						obj.petition_has_sample ={
							petitions_id: this.state.petition_id,
							entry_date: date,
							samples_id: this.state.samples_id,
						};
					}	

					obj.sample.convoke_places_id =  parseInt(this.state.convoke_places_id, 10);
					obj.sample.id = this.state.samples_id;
					obj.sample.number = this.state.sample_number;
					obj.sample.petition_id = this.state.petition_id;
					obj.sample.taked_by = this.state.sample_person;
					if(this.state.reason_id !== ""){
						obj.sample.samples_has_incidents = [{
							rejection_reason:this.state.reason_id,
							samples_id:this.state.samples_id,
							observations: this.state.observations
						}];
					}

					if(this.state.reject_id !== ""){

						obj.sample.samples_has_incidents.id = this.state.reject_id;
					}
				
				}else{
					obj.sample = {
						convoke_places_id: parseInt(this.state.convoke_places_id, 10),
						timestamp: date,
						sample_number: this.state.sample_number,
						taked_by: this.state.sample_person,
						sample_types_id: null,
						patient_id:this.state.patient_id
					};
					if(this.state.reason_id !== ""){
						obj.sample.samples_has_incidents = [{rejection_reason:this.state.reason_id, observations: this.state.observations}];
					}
					obj.petition_has_sample ={
						petitions_id: this.state.petition_id,
						entry_date: date
					};
					
					api = 'samples/patient_sample?health_facilities_id='+
							sessionStorage.getItem('health_facilities_id');
					method = 'POST';

				}

				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+api, {
					method:method,
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res =>{
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						//this.handleClose();
						if(method === 'POST'){
							this.setState({samples_id:response.sample.id, disableSave:true });
							//this.printSampleLabel(response.sample.id);
						}
						
						swal('Correcto', 'Registro guardado correctamente', 'success');
						
						//this.props.history.push('/petition_register');
					}
				});

			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}
		}else{
			swal('Error', 'Debe seleccionar una muestra o generar un nuevo registro.', 'error');
		}	
	}

	printSampleLabel(e, id){
		e.preventDefault();

		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+'&file_type=label_samples&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
			  });
			}})
		.then(response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta para el \"Registro de Muestras\"", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');

				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = id;
				obj.file_type = "label_samples";
				obj.nEtiqueta = [];

				fetch(Config.default.apiGateway.URL+"labelsEditor", {
					method : 'post',
					body:JSON.stringify(obj),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.blob();
					}else{
					  res.text().then(function(result) {
						swal('¡Error', result, 'error');
						return;
					  });
					}
				})
				.then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
							//PREVIEW
							var fileURL = URL.createObjectURL(response);
							window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = function() {
								var base64data = reader.result;  
								var aux = base64data.split(',');
								socket.send('{"Operacion":"print", "Type":"label_sample_patients", "File": "'+aux[1]+'"}');
							}
						}
						
						this.handleClose();
						//this.setState({ show: false});
					}
				})
			}
		});
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
    			
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
	    			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			
			if(this.state[refName] !== undefined){
				
				if(this.state[refName] === ""){
					
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
						
					}
					res = true;
				}
			}else{
				
				
				if(control.value === ""){
					
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
						
					}
					res = true;
				}
			}
		}
		

		return res;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			form.elements[index + 1].focus();
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	clear(){
  		this.getServerTime();
  		this.getPlaces();
  		
  		this.setState({
			sample_number:"",
			origin:"",
			sample_person:"",
			convoke_places_id:"",

			antibodies_required: null,
			donation_id: "",
			donor_id: "",
			number: "",
			offers_id: "",
			sample_types_id:"",
			storage_ubication_id:"",
			validated:"",
			validation_status:"",

			sample:"",
			showForm: true,	
			samples_id:"",
		});
  	}

  	onUpdate(e){
  		var sample_id = parseInt(this.state.sample);
  		var index = this.state.samples.findIndex(obj => obj.sample.id === sample_id);
  		this.getPlaces();

  		if(index !== -1){
  			var item = this.state.samples[index];

  			if(item.petition_has_sample !== null){
  				
  				this.setState({
  					entry_date: item.petition_has_sample.entry_date.split('T')[0],
		           	entry_hour: moment(item.petition_has_sample.entry_date.split('T')[1], 'HH:mm').format('HH:mm'),
		           	sample_date: item.sample.timestamp.split('T')[0],
		           	sample_hour: moment(item.sample.timestamp.split('T')[1], 'HH:mm').format('HH:mm'),
  				});
  			}else{
  				this.getServerTime('entry');
				this.setState({
  					sample_date: item.sample.timestamp.split('T')[0],
		           	sample_hour: moment(item.sample.timestamp.split('T')[1], 'HH:mm').format('HH:mm'),
  				});
	  				
  			}

  			if(item.incident === null){
  				this.setState({
					no_apto:false,
					reason_id:"",
					observations:""
				})
  			}else{
  				this.setState({
					no_apto:true,
					reason_id:item.incident.rejection_reason,
					observations:item.incident.observations,
					reject_id:item.incident.id
				})
  			}

	  		this.setState({
	           antibodies_required: item.sample.antibodies_required,
	           donation_id:item.sample.donation_id,
	           donor_id:item.sample.donor_id,
	           sample_number: item.sample.number,
	           offers_id: item.sample.offers_id,
	           sample_types_id: item.sample.sample_types_id,
	           storage_ubication_id: item.sample.storage_ubication_id,
	           convoke_places_id: item.sample.convoke_places_id !== null ? item.sample.convoke_places_id : "" ,
	           sample_person: item.sample.taked_by,
	           validated: item.sample.validated,
	           validation_status: item.sample.validation_status,
	           samples_id: sample_id,
	           patient_id: item.sample.patient_id,
	           //sample: "",
	           showForm:true,
	       	});

  		}else{
  			swal('Error', 'Debe seleccionar una muestra.', 'error');
  		}
  	}

  	onChecked(e){

  		this.setState({
  			no_apto: e.target.checked ? true : false
  		});
  	}

	render(){
		const {t} = this.props;

		return (
			<Modal backdrop="static" keyboard={false} dialogClassName="modal-samples" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Datos de la Muestra</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			{/*<Table>
		        				<thead>
		        					<tr>
		        						<th>Muestra</th>
		        						<th>Estatus</th>
		        						<th>Fecha Muestra</th>
		        						<th>Fecha Entrada</th>
		        						<th>Lugar Colecta</th>
		        						<th>Tomada Por</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.samples.map((s, i)=>(
		        						<tr key={i}>
		        							<td>{s.sample.number}</td>
		        							<td>{s.sample.expired_date !== null ? 'Caducada' : ''}</td>
		        							<td>
		        								{moment(s.sample.timestamp).format('DD/MM/YYYY HH:mm')}
		        							</td>
		        							<td>
		        								{moment(s.petition_has_sample.entry_date).format('DD/MM/YYYY HH:mm')}
		        							</td>
		        							<td>
		        								{this.state.convoke_places.map((t)=>(
		        									t.convoke_places.id === s.sample.convoke_places_id ?
									                  	<option key={t.convoke_places.id} value={t.convoke_places.id} >
									                  		{t.convoke_places.name} 
									                  	</option>
									                : null
								                ))}
		        							</td>
		        							<td>{s.sample.taked_by}</td>
		        						</tr>
		        					))}
		        				</tbody>
		        			</Table>*/}



			        		<form noValidate>
		        				<div className="col-xs-12">
		        					<div className="col-xs-12 col-sm-4">
		        						<span className="span-min">Muestras</span>
		        						<select className="form-control" name="sample" id="sample" disabled
		        							onChange={this.handleChange} value={this.state.sample}>
		        							<option value="">Seleccionar...</option>
		        							{this.state.samples.map((s, i)=>{
		        								return <option key={i} value={s.sample.id}>
		        									{s.sample.number} - {moment(s.sample.timestamp, 'YYYY-MM-DD H:mm').format('DD/MM/YYYY HH:mm')} 
												{s.sample.expired_date !== null ? ' - '+ 'Caducada' : ''}
		        								</option>
		        							})}
		        						</select>
		        					</div>
		        					
		        					{/*<div className="col-xs-12 col-sm-2" style={{marginTop:"18px"}}>
		        						<button type="button" className="btn btn-info" onClick={this.clear}>
		        							Nuevo
		        						</button>
		        					</div>*/}
		        					<br/><hr style={{width:"100%", marginTop:"3em"}}/>
		        				</div>
			        		

			        			{this.state.showForm ? 
			        				<div>
			        					<div className="col-xs-12">
						        			<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Fecha Entrada</span>
						        				<input type="date" name="entry_date" id="entry_date" className="form-control"
						        					value={this.state.entry_date} onChange={this.handleChange} required 
						        					onKeyPress={this.validateInput} disabled/>
						        			</div>
						        			<div className="col-xs-12 col-sm-2">
						        				<span className="span-min">Hora</span>
						        				<input id="entry_hour" name="entry_hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
													data-inputmask-placeholder="-" value={this.state.entry_hour || ""} onChange={this.handleChange}
													required className="form-control" onKeyPress={this.validateInput} disabled/>
						        			</div>
						        			<div className="col-xs-11 col-sm-5">
						        				<span className="span-min">Muestra Número</span>
						        				<input type="number" className="form-control input-hour" disabled
						        					name="sample_number" id="sample_number" required value={this.state.sample_number}
						        					onChange={this.handleChange} onKeyPress={this.validateInput} />
						        			</div>
						        			{/*<div className="col-xs-1 col-sm-1" style={{textAlign:'right'}}>
												<Button className="btn btn-info btn-xs" style={{marginTop:"21px"}} type="button" 
													title="Generar Número de Donación" onClick={this.getNextNumber} >
													<SvgIcon icon={download} style={{paddingTop:"3px"}}/>
												</Button>
											</div>*/}
						        		</div>
						        		<div className="col-xs-12">
						        			<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Fecha Muestra</span>
						        				<input type="date" name="sample_date" id="sample_date" value={this.state.sample_date}
						        					className="form-control" onChange={this.handleChange} onKeyPress={this.validateInput} disabled/>
						        			</div>
						        			<div className="col-xs-12 col-sm-2">
						        				<span className="span-min">Hora</span>
						        				<input id="sample_hour" name="sample_hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
													data-inputmask-placeholder="-" value={this.state.sample_hour || ""} onChange={this.handleChange}
													className="form-control" onKeyPress={this.validateInput} disabled/>
						        			</div>
						        			<div className="col-xs-12 col-sm-6">
						        				<span className="span-min">{t('content.offers.form.convoke_place')}</span>
												<select className="form-control" name="convoke_places_id" id="convoke_places_id" 
													value={this.state.convoke_places_id} onChange={ this.handleChange } disabled
													onKeyPress={this.validateInput}>
									              	<option value="">Seleccionar...</option>
									                {this.state.convoke_places.map(function(t) {
									                  	return <option key={t.convoke_places.id} value={t.convoke_places.id} >
									                  		{t.convoke_places.name} 
									                  	</option>;
									                })}
								              	</select>
						        			</div>

						        		</div>

						        		<div className="col-xs-12 form-group">
						        			<div className="col-xs-12">
						        				<span className="span-min">Muestra tomada por</span>
						        				<input type="text" name="sample_person" id="sample_person" value={this.state.sample_person} disabled
						        					className="form-control" onChange={this.handleChange} onKeyPress={this.validateInput} />
						        			</div>
						        		</div>

						        		{/*<div className="col-xs-12">
						        			<div className="col-xs-12">
												<input type="checkbox" checked={this.state.no_apto} onChange={this.onChecked} />
												<span style={{marginLeft:'10px'}}>NO APTO</span>
											</div>
										</div>

										{this.state.no_apto ?
											<div className="col-xs-12">
												<div className="col-xs-4">
													<span className="span-min">Motivo</span>
													<select className="form-control" id="reason_id" name="reason_id" value={this.state.reason_id}
														onChange={this.handleChange}>
														<option value="">Seleccione...</option>
														{this.state.reasons.map((r, i)=>(
															<option key={i} value={r.key}>{r.name}</option>
														))}
													</select>												
												</div>
											</div>
										:null}
							        	
							        	{/*this.state.no_apto ?
											<div className="col-xs-12">
												<div className="col-xs-12">
													<span className="span-min">Observaciones</span>
													<textarea className="form-control" value={this.state.observations}
														onChange={this.handleChange} name="observations" id="observations"
														style={{width:"100%",resize:"none"}}></textarea>
												</div>
											</div>
										:null*/}
											

						        		<div className="col-xs-12" style={{marginTop:'10px', textAlign:'center'}}>
											<button className="toolIcon" disabled={this.state.samples_id === ""} 
												onClick={(e)=>this.printSampleLabel(e, this.state.samples_id)}>
												<SvgIcon size={40} icon={ic_local_offer} />
												<div className="col-xs-12">
													<span>{t('toolbar.labels')}</span>
												</div>
											</button>
										</div>

			        				</div>
			        			: null}
						        		
				        	</form>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{/*<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.onSave} 
		        	disabled={this.state.disableSave} />*/}
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
}
export default translate('translations') (ModalSample);